import { render, staticRenderFns } from "./ManualRunesDescription.vue?vue&type=template&id=5de5201c&"
import script from "./ManualRunesDescription.vue?vue&type=script&lang=js&"
export * from "./ManualRunesDescription.vue?vue&type=script&lang=js&"
import style0 from "./ManualRunesDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports